import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TGetNewMessageCountResponsePayload,
	TMessagesResponseData,
	TOrganizationsData,
	TOrganizationsRow,
	TUserInfoData,
	TUserStore,
	THubspotVisitorTokenResponsePayload,
} from './types';

export const getUserState = (state: TStoreState): TUserStore => state.user;

export const getUser = createSelector([getUserState], (user: TUserStore) => user);

// ==========================================:

// export const getUserIsLoad = createSelector(
// 	[getUser],
// 	(user: TUserStore): boolean => user.userLoader,
// );

// ==========================================:

export const getUserOrganizations = createSelector(
	[getUser],
	(user: TUserStore): TOrganizationsData => user.organizations,
);

// ==========================================:

export const getUserOrganizationsLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.organizationsLoader,
);

// ==========================================:

export const getUserInfo = createSelector(
	[getUser],
	(user: TUserStore): TUserInfoData => user.userInfo,
);

// ==========================================:

export const getUserInfoLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.userInfoLoader,
);

// ==========================================:

export const getOrganization = createSelector(
	[getUser],
	(user: TUserStore): TOrganizationsRow | null => user.setOrganization,
);

// ==========================================:

export const getNewMessageCount = createSelector(
	[getUser],
	(user: TUserStore): TGetNewMessageCountResponsePayload => user.newMessageCount,
);

// ==========================================:

export const getNewMessageCountLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.newMessageCountLoader,
);

// ==========================================:

export const getMessages = createSelector(
	[getUser],
	(user: TUserStore): TMessagesResponseData => user.messages,
);

// ==========================================:

export const getMessagesLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.messagesLoader,
);

// ==========================================:

export const getHubspotVisitorToken = createSelector(
	[getUser],
	(user: TUserStore): THubspotVisitorTokenResponsePayload => user.hubsportVisitorToken,
);

// ==========================================:

export const getHubspotVisitorTokenLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.hubsportVisitorTokenLoader,
);
